import { render, staticRenderFns } from "./vehiclechecks.html?vue&type=template&id=b6715d46&scoped=true&external"
import script from "./vehiclechecks.vue?vue&type=script&lang=js"
export * from "./vehiclechecks.vue?vue&type=script&lang=js"
import style0 from "./vehiclechecks.vue?vue&type=style&index=0&id=b6715d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6715d46",
  null
  
)

export default component.exports